export default "__VITE_ASSET__12c8b53d__"